import styles from "./StatusBadge.module.css";

type Props = {
  status: string;
};

function humanizeStatus(status: string): string {
  return status.charAt(0).toUpperCase() + status.slice(1);
}

function statusClass(status: string): string {
  if (status === "draft") return styles.draft;
  if (status === "published") return styles.published;
  return styles.draft;
}

export function StatusBadge({ status }: Props) {
  return <span className={`${styles.badge} ${statusClass(status)}`}>{humanizeStatus(status)}</span>;
}
